import { Box, Typography, useTheme } from "@mui/material";
import { SenecEkpTheme } from "src/styles/ekp-theme/senecEkpTheme";
import { WarningIcon } from "src/components/error/error-illustrations/WarningIcon";
import { useScreenSize } from "src/hooks/useScreenSize";

export interface EkpComponentErrorProps {
    /**
     * Error message to be displayed for component error.
     */
    errorMsg: string;
    /**
     * Error code to be displayed for component error.
     */
    errorCode?: string;
}

/**
 * EkpComponentError used to notify the user of an error while loading a component.
 */

export const EkpComponentError = (props: EkpComponentErrorProps) => {
    const theme: SenecEkpTheme = useTheme();
    const { isMobile, isTablet } = useScreenSize();

    return (
        <Box sx={{ backgroundColor: theme.palette.senecPrimary.white }}>
            <Box display="flex" flexDirection="row" alignItems="flex-start" p={2} m={"auto"} width={"fit-content"}>
                <Box display="flex" alignItems={"center"} data-testid={"error-icon"} pr={1}>
                    <WarningIcon />
                </Box>
                <Box display="flex" flexDirection={isMobile || isTablet ? "column" : "row"} alignSelf={"center"}>
                    <Typography
                        variant={"h5"}
                        lineHeight={"150%"}
                        color={theme.palette.senecSecondary.neutralGray70}
                        paddingRight={isMobile || isTablet ? "0" : "4px"}
                    >
                        {props.errorMsg}
                    </Typography>
                    {props.errorCode ? (
                        <Typography
                            variant={"h5"}
                            fontWeight={400}
                            lineHeight={"150%"}
                            color={theme.palette.senecSecondary.neutralGray50}
                        >
                            {props.errorCode}
                        </Typography>
                    ) : null}
                </Box>
            </Box>
        </Box>
    );
};
